import { type Components, type Theme } from "@mui/material/styles";

import { muiAvatarOverrides } from "./overrides/avatar";
import { muiBadgeOverrides } from "./overrides/badge";
import { muiButtonOverrides } from "./overrides/button";
import { muiScrollbarOverrides } from "./overrides/scrollbar";
import { muiTabsOverrides } from "./overrides/tabs";

export const muiThemeComponents: Components<Theme> = {
  ...muiButtonOverrides,
  ...muiAvatarOverrides,
  ...muiBadgeOverrides,
  ...muiTabsOverrides,
  ...muiScrollbarOverrides,
};
